<template>
  <div>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Módosítás'"
      placement="top"
      v-can="'shopcategory.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateShopCategory"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'shopcategory.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteShopCategory"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>
<script>
  export default {
    props: ['shopCategory'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false
      };
    },
    methods: {
      async deleteShopCategory() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('shopCategory/delete', this.shopCategory.id);
          this.$store.dispatch('shopCategory/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updateShopCategory() {
        this.$router.push('/data/shops/categories/update/' + this.shopCategory.id);
      }
    }
  };
</script>
